<template lang="pug">
  .contacts_list
    .contacts_head(v-if="data.length")
      .contacts_title {{ title }}
    ContactListItem(
      v-for="(item, index) in data",
      :key="'contact_' + item.id",
      :contact="item",
      :disabled="disabled")
</template>

<script>
import ContactListItem from '@/components/ContactListItem';

export default {
  components: {
    ContactListItem
  },
  props: {
    title: { type: String, required: true },
    data: { type: Array, required: true },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/variables';

  .contacts {
    &_head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      padding: 0 21px 0 23px;
      position: sticky;
      top: -1px;
      background: $white;
      z-index: 3;

      @media screen and (max-width: 1024px) {
        padding-right: 10px;
        padding-left: 10px;
      }

      &::after {
        content: '';
        background: linear-gradient(180deg, $white 0%, $avatar-gradient-to 100%);
        height: 30px;
        width: 100%;
        position: absolute;
        bottom: -29px;
        left: 0;
      }
    }

    &_title {
      line-height: normal;
      font-size: 16px;
      font-weight: 600;
      color: $grey-text;
    }

    &_list {
      margin-bottom: 21px;

      &:last-child { margin-bottom: 0; }

      .group,
      .ticked {
        display: none;
      }
    }
  }
</style>
